// removed by extract-text-webpack-plugin
module.exports = {"btnAccent":"pnr-form__btnAccent___1noqP globals__btn___2fgn7","wrapper":"pnr-form__wrapper___3JaMl","header":"pnr-form__header___3ixn3","icon":"pnr-form__icon___1SEdl","form":"pnr-form__form___3jiqQ","formControl":"pnr-form__formControl___3cx9E","errorMessage":"pnr-form__errorMessage___C7pnz"};


//////////////////
// WEBPACK FOOTER
// ./src/components/pnr-form/pnr-form.scss
// module id = 592
// module chunks = 0